export const convertToEnglishNumber = (input: string) => {
  const persianNumbers = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
  const arabicNumbers = ["٠", "١", "٢", "٣", "٤", "٥", "٦", "٧", "٨", "٩"];
  const englishNumbers = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];
  
  return input
    .replace(/[۰-۹]/g, (w) => englishNumbers[persianNumbers.indexOf(w)])
    .replace(/[٠-٩]/g, (w) => englishNumbers[arabicNumbers.indexOf(w)]);
};
